import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/** IT Policies > Confirmations: ultima runda a politicii pentru firma din antet (CyFun GV.PO-01.1). */
export type PolicyAckPerson = {
  id: number
  employee_id: number
  name: string
  email: string
  sent_at: string
  reminded_at: string | null
  confirmed_at: string | null
}

export type PolicyAcksPage = {
  ready: boolean
  company: { id: number; name: string } | null
  canSend: boolean
  recipients: number
  round: { id: number; sent_at: string; recipients: number; confirmed: number } | null
  people: PolicyAckPerson[]
  sent?: number
  reminded?: number
  failed?: number
}

export function policyAcksQuery(subcategory: number) {
  return queryOptions({
    queryKey: ['easeedesk', 'it-policies', subcategory, 'acks'],
    queryFn: () => apiGet<PolicyAcksPage>(`/easeedesk/it-policies/${subcategory}/acks`),
  })
}

export function sendPolicyAcks(subcategory: number) {
  return apiPost<PolicyAcksPage>(`/easeedesk/it-policies/${subcategory}/acks`, {})
}

export function remindPolicyAcks(round: number) {
  return apiPost<PolicyAcksPage>(`/easeedesk/it-policies/acks/${round}/remind`, {})
}

/**
 * Pagina din linkul de email, FARA sesiune: nu trece prin `apiGet`, care la 401
 * ar trimite omul la "Sign in" - angajatul n-are cont. Orice raspuns care nu e
 * 200 inseamna ca linkul nu mai e bun (vezi `easeedeskCustomerTicket.ts`).
 */
export type PublicPolicyAck = { title: string; company: string; name: string; body: string; confirmedAt: string | null }

export class PolicyAckLinkGone extends Error {
  constructor() {
    super('This link is no longer valid.')
    this.name = 'PolicyAckLinkGone'
  }
}

async function publicCall(token: string, method: 'GET' | 'POST'): Promise<PublicPolicyAck> {
  const response = await fetch(`/api/v2/public/policy-ack/${encodeURIComponent(token)}`, { method, headers: { Accept: 'application/json' } })
  if (!response.ok) throw new PolicyAckLinkGone()

  return (await response.json()) as PublicPolicyAck
}

export function publicPolicyAckQuery(token: string) {
  return queryOptions({
    queryKey: ['public', 'policy-ack', token],
    queryFn: () => publicCall(token, 'GET'),
    retry: false,
  })
}

export function confirmPublicPolicyAck(token: string) {
  return publicCall(token, 'POST')
}
